import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { JsonResponse } from "@shared/interfaces/JsonResponse.interface";
import { BehaviorSubject, Observable, tap } from "rxjs";
import { ToasterService } from "./toaster.service";
import { Lab, LabAvailableTimeslot } from "@shared/interfaces/Lab.interface";
import { LocalStorageService } from "ngx-webstorage";
import {TranslateService} from "@tolgee/ngx";

@Injectable({
    providedIn: 'root'
})
export class LabService {

    private _labData$$: BehaviorSubject<Lab> = new BehaviorSubject<Lab>(null);
    public labData$: Observable<Lab> = this._labData$$.asObservable()

    constructor(
        private _http: HttpClient,
        private _toasterService: ToasterService,
        private _localStorageService: LocalStorageService,
        private _translateService: TranslateService
    ) { }

    get labData(): Lab {
        return this._labData$$.getValue();
    }

    public getLabData(): void {
        this._http.get<JsonResponse<Lab>>('/lab/get-lab-data').pipe(
            tap(res => {
                if (!res.success) {
                    this._toasterService.error('error', res.message);
                }
            })
        ).subscribe(res => {
            if (res.success) {
                this._labData$$.next(res.data);

                if (res.data?.company?.bannerUrls?.thumb300) {
                    this._localStorageService.store("logo", res.data.company.bannerUrls?.thumb300);
                }
                
                if (!this._localStorageService.retrieve('lng')) {
                    
                    const defaultLang = res.data.country?.language?.code || 'en';
                    
                    this._localStorageService.store('default-lng', defaultLang);
                    this._translateService.changeLanguage(defaultLang).then(() => { })
                }

            }
        });
    }

    public getDoctorLabData(): void {
        this._http.get<JsonResponse>('/lab/get-doctor-lab-data').pipe(
            tap(res => {
                if (!res.success) {
                    this._toasterService.error('error', res.message);
                }
            })
        ).subscribe(res => {
            if (res.success) {
                this._labData$$.next(res.data);
            }
        });
    }

    public getLabAvailableTimeslots(startDate: string, endDate: string, opts?: { disableDailyCapacity?: boolean; disableLabAppointmentSlots?: boolean }): Observable<JsonResponse<LabAvailableTimeslot[]>> {
        
        const params: any = {
            startDate,
            endDate
        }

        if (opts?.disableDailyCapacity) {
            params.disableDailyCapacity = true;
        }

        if (opts?.disableLabAppointmentSlots) {
            params.disableLabAppointmentSlots = true;
        }
        
        return this._http.get<JsonResponse<LabAvailableTimeslot[]>>('/lab/get-available-timeslots', {
            params
        }).pipe(
            tap(res => {
                if (!res.success) {
                    this._toasterService.error('error', res.message);
                }
            })
        )
    }
}
